import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { UnlockButton } from './UnlockButton';
import { PLAN_PRICES_USD, formatUsd } from '../../../data/pricingPlans';
import type { CheckoutState } from '../../../hooks/useReportUnlock';
interface MobileUnlockBarProps {
  visible: boolean;
  state: CheckoutState;
  error: string | null;
  onUnlock: () => void;
}
function statusLine(state: CheckoutState, error: string | null): string | null {
  if (state === 'error' && error) return error;
  if (state === 'timed_out') return 'Still locked — if you were charged, it will unlock shortly.';
  if (state === 'still_locked') return 'Still locked — checkout didn’t complete.';
  return null;
}

/** Keeps the $2.99 unlock within thumb reach on mobile while the main card is off-screen. */
export function MobileUnlockBar({
  visible,
  state,
  error,
  onUnlock
}: MobileUnlockBarProps) {
  const status = statusLine(state, error);
  return <AnimatePresence data-id="element-252" data-mp="9fd2fwjjubgv">
      {visible && <motion.div initial={{
      y: '100%'
    }} animate={{
      y: 0
    }} exit={{
      y: '100%'
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-forensic-line bg-forensic-bg/95 px-4 pb-[calc(env(safe-area-inset-bottom)+12px)] pt-3 backdrop-blur md:hidden" data-id="element-253" data-mp="mqj3kikc1xt5">
          <UnlockButton label={`Unlock Full Report — ${formatUsd(PLAN_PRICES_USD.single_scan)}`} state={state} onClick={onUnlock} fullWidth data-id="element-254" data-mp="8sulfihnh4rs" />
          {status ? <p role={state === 'error' ? 'alert' : 'status'} className={`mt-1.5 line-clamp-2 text-center text-xs leading-snug ${state === 'error' ? 'text-forensic-crimson-soft' : 'text-forensic-muted'}`} data-id="element-255" data-mp="wop5h06533y0">
              {status}
            </p> : <p className="mt-1.5 text-center text-xs text-forensic-subtle" data-id="element-256" data-mp="1ke9spv9bsnd3">
              One-time · No subscription
            </p>}
        </motion.div>}
    </AnimatePresence>;
}